import { List, Typography } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import type { MouseEvent } from 'react';

import styles from './compareMenuItem.module.css';

interface CompareMenuItemProps {
  disabled?: boolean;
  isSelected: boolean;
  onToggle: () => void;
  productName: string;
}

export const CompareMenuItem = ({
  disabled = false,
  isSelected,
  onToggle,
  productName,
}: CompareMenuItemProps) => {
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onToggle();
  };

  return (
    <List.Item disableHover px={0} py={0}>
      {/* TODO: replace this with a shared Reefer
          Pill/Chip (selectable variant) once it exists
          https://www.figma.com/design/acoTASmDAGFqgCe4buL7CE/Reefer?node-id=26418-7173 */}
      <button
        type="button"
        className={clsx(styles['menuItem'], {
          [styles['menuItem__active']]: isSelected,
        })}
        disabled={disabled}
        onClick={handleClick}
        aria-label={`Compare ${productName}`}
        aria-pressed={isSelected}
      >
        <span className={styles['indicator']} aria-hidden="true" />
        <Typography as="span" color="grays-black" className={styles['label']}>
          Compare
        </Typography>
      </button>
    </List.Item>
  );
};
